<template>
  <div class="banner">
    <carousel
      :perPage="1"
      :pagination-enabled="true"
      :autoplay="true"
      :autoplayTimeout="3000"
      :loop="true"
    >
      <slide v-for="item in items" :key="item.id">
        <button class="banner-content" :style="bannerStyle"></button>
      </slide>
    </carousel>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    bannerStyle() {
      return {
        "background-image": `url(${require("@/assets/images/slide_background_sample.png")})`
      };
    }
  },
  mounted() {
    setTimeout(() => {
      let slides = document.getElementsByClassName("VueCarousel-dot");
      slides.forEach((item, index) => {
        slides[index].removeAttribute("title");
      });
    }, 200);
  }
};
</script>
<style lang="scss" scoped>
.banner {
  ::v-deep .VueCarousel-pagination {
    bottom: 0px;
    position: absolute;
  }

  ::v-deep .VueCarousel-dot {
    border-radius: 0px;
    height: 2px !important;
    width: 20px !important;
    background-color: #c4c4c4 !important;

    &.VueCarousel-dot--active {
      background-color: #fff !important;
      width: 30px !important;
    }
  }

  ::v-deep .VueCarousel-dot:focus {
    outline: none;
  }

  .banner-content {
    border-radius: 10px;
    border: none;
    position: relative;
    width: 100%;
    padding-bottom: 20%;
    max-height: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media screen and (max-width: 768px) {
      padding-bottom: 50%;
    }
  }
}
</style>
